import { waLink } from "../data/content";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/5 bg-slatewarm">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 flex flex-col md:flex-row md:items-end md:justify-between gap-10">
      <div>
        <p className="font-serif-lux text-3xl text-bone">
          Raditya <span className="italic text-gold">Konstruksi</span>
        </p>
        <p className="text-sm text-dim font-light mt-3 max-w-xs leading-relaxed">
          Masterpiece hunian mewah berstandar presisi tinggi. Jakarta — Bali — Surabaya.
        </p>
      </div>
      <div className="flex flex-col items-start md:items-end gap-3">
        <a
          data-testid="footer-whatsapp-btn"
          href={waLink()}
          target="_blank"
          rel="noopener noreferrer"
          className="font-mono-arch text-[11px] tracking-[0.22em] uppercase text-gold hover:text-bone transition-colors"
        >
          +62 812-8015-2007 (WhatsApp)
        </a>
        <p className="font-mono-arch text-[10px] tracking-[0.2em] uppercase text-dim">
          © {new Date().getFullYear()} PT Raditya Konstruksi
        </p>
      </div>
    </div>
  </footer>
);
